import { render } from "./ProjectItem.vue?vue&type=template&id=6dc027f2"
import script from "./ProjectItem.vue?vue&type=script&lang=js"
export * from "./ProjectItem.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__